import React, { useEffect, useState } from "react";
import * as S from "./ContentExtra.style";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import noExtraContent from './no-extra-content.png';
import { useTranslation } from "react-i18next";

function ContentExtra ({
  content
}) {  

  const {t, i18n: { language }} = useTranslation("global");  

  return (
    <S.ContentExtra>
      {/* {
        [1,2,3,4,5].map((item, index) => (
          <div className="extra-item" key={index}>
            <div className="symbol">✱</div>
            <div className="extra-data">
              <div className="extra-title">
                Nutrición para Pacientes con Cáncer - Episodio {item}
              </div>
              <div className="extra-description">
                Este episodio cubre los fundamentos de la nutrición y su importancia en el tratamiento del cáncer.
              </div>
            </div>
          </div>
        ))
      } */}
      <div className="no-content">
        <img className="no-content__img" src={noExtraContent} alt="no-extra-coSntent" />
        {/* <div className="no-content__img">
          
        </div> */}
        <div className="no-content__text">
          {
            t('globally.noExtraContent')
          }
        </div>
      </div>
    </S.ContentExtra>
  )

}

export default ContentExtra;
